import { ComponentPropsWithRef } from "react";

export const SendIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6648_1092)">
      <path
        d="M21.014 39.5836L41.8565 11.7143L7.2997 15.8298L12.6198 25.075L33.9385 16.2858L15.6675 30.3536L21.014 39.5836Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6648_1092">
        <rect width="48" height="48" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
